import { render } from "./HeroComponent.vue?vue&type=template&id=668fe966&scoped=true"
import script from "./HeroComponent.vue?vue&type=script&lang=js"
export * from "./HeroComponent.vue?vue&type=script&lang=js"

import "./HeroComponent.vue?vue&type=style&index=0&id=668fe966&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668fe966"]])

export default __exports__